module.exports = __webpack_public_path__ + "img/circle-plus 1.a0538400.svg";